import { jsx as t, jsxs as l } from "react/jsx-runtime";
import "react";
var s = (i) => /* @__PURE__ */ l("svg", {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...i,
  children: [/* @__PURE__ */ t("path", {
    d: "M7.11068 2.66672C7.11068 2.1758 7.50865 1.77783 7.99957 1.77783C8.49049 1.77783 8.88845 2.1758 8.88845 2.66672V13.3334C8.88845 13.8243 8.49049 14.2223 7.99957 14.2223C7.50865 14.2223 7.11068 13.8243 7.11068 13.3334V2.66672Z",
    fill: "white"
  }), /* @__PURE__ */ t("path", {
    d: "M13.3329 7.11117C13.8238 7.11117 14.2218 7.50913 14.2218 8.00005C14.2218 8.49097 13.8238 8.88894 13.3329 8.88894L2.66623 8.88894C2.17531 8.88894 1.77734 8.49097 1.77734 8.00005C1.77734 7.50913 2.17531 7.11117 2.66623 7.11117L13.3329 7.11117Z",
    fill: "white"
  })]
});
export {
  s as default
};
